/**
 * Created by mh on 2017/5/23.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import JobModel from './model/JobModel';

const PriorityToColorClass = (priority) => {
    switch (parseInt(priority, 10)) {
    case 0:
        return 'badge-danger';
    case 1:
        return 'badge-warning';
    case 2:
        return 'badge-info';
    case 3:
        return 'badge-secondary';
    default:
        return 'badge-secondary';
    }
};

const StatusToColorClass = (status) => {
    switch (status) {
    case 'init':
        return 'badge-secondary';
    case 'queued':
        return 'badge-info';
    case 'running':
        return 'badge-primary';
    case 'completed':
        return 'badge-success';
    case 'success':
        return 'badge-success';
    case 'error':
        return 'badge-danger';
    default:
        return 'badge-secondary';
    }
};

const StatusToProgressClass = (status) => {
    switch (status) {
    case 'completed':
        return 'bg-success';
    case 'success':
        return 'bg-success';
    case 'error':
        return 'bg-danger';
    default:
        return 'progress-bar-animated';
    }
};

@observer
export default class JobTableRow extends React.Component {
    render() {
        const { job } = this.props;
        return (
            <tr>
                <th className="align-middle" scope="row">{job.type}</th>
                <td className="align-middle">
                    <Link className="" to={`details/${job.id}/`}>
                        {job.name}
                    </Link>
                </td>
                <td className="align-middle">{job.instance}</td>
                <td className="align-middle">
                    <span className={`badge ${StatusToColorClass(job.status)}`}>
                        {job.status}
                    </span>
                </td>
                <td className="align-middle">
                    <span className={`badge ${PriorityToColorClass(job.priority)}`}>
                        {job.priorityText}
                    </span>
                </td>
                <td className="align-middle">
                    <div className="progress">
                        <div
                            className={`progress-bar progress-bar-striped ${StatusToProgressClass(job.status)}`}
                            role="progressbar"
                            style={{ width: `${job.progress}%` }}
                            aria-valuenow={job.progress}
                            aria-valuemin="0"
                            aria-valuemax="100" />
                    </div>
                </td>
                <td className="align-middle">
                    <Link className="btn btn-sm btn-secondary" to={`details/${job.id}/`}>+</Link>
                </td>
            </tr>);
    }
}

JobTableRow.propTypes = {
    job: PropTypes.instanceOf(JobModel).isRequired,
};
